<template >
  <el-container class="dashboard-tab" style="text-align:center">
    <el-col :span="24">
      <el-row :span="24">
        <DateInput v-on:setDate="setDate" />
      </el-row>
      <el-row>
        <el-col :span="24">
          <HealthProgress_ProgressChart class="bordered" :startDate="startDate" :endDate="endDate" :unit="unit"
            :interval="interval" />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-row>
            <el-col :span="8">
              <SystemHealth_PieChart class="bordered" :startDate="startDate" :endDate="endDate" :unit="unit"
                :interval="interval"></SystemHealth_PieChart>
            </el-col>
            <el-col :span="16">
              <LastReports class="bordered"></LastReports>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <FailureMode_PieChart class="bordered" :startDate="startDate" :endDate="endDate" />

            </el-col>
            <el-col :span="8">
              <UnresolvedReports_Gauge class="bordered"></UnresolvedReports_Gauge>

            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <PointHealthPerformance class="bordered"></PointHealthPerformance>

        </el-col>

      </el-row>
    </el-col>
  </el-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { treeHelper, colorLib } from "../util";
import preferences from "../util/preferences";

import UnresolvedReports_Gauge from "./Dashboard/UnresolvedReports_Gauge.vue";
import SystemHealth_PieChart from "./Dashboard/SystemHealth_PieChart.vue";
import HealthProgress_ProgressChart from "./Dashboard/HealthProgress_ProgressChart.vue";
import FailureMode_PieChart from "./Dashboard/FailureMode_PieChart.vue";
import LastReports from "./Dashboard/LastReports.vue";
import DateInput from "./Dashboard/DateInput.vue";
import PointHealthPerformance from "./Dashboard/PointHealthPerformance.vue";
import dayjs from "dayjs-ext";

export default {
  name: "DashboardTab",
  components: {
    SystemHealth_PieChart,
    HealthProgress_ProgressChart,
    FailureMode_PieChart,
    UnresolvedReports_Gauge,
    LastReports,
    PointHealthPerformance,
    DateInput
  },
  props: {
    reload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      needsCheck: [
        {
          point: "Group 1 > Point 1",
          health: 0.5
        },
      ],
      startDate: dayjs().subtract(24, 'hour').format('YYYY-MM-DDTHH:mm:ss'),
      endDate: dayjs().format('YYYY-MM-DDTHH:mm:ss'),
      unit: "day",
      interval: {},
      colorSet: ["#F1A935", "#3E87A5", "#6EBE9F", "#C94A58", "#55596A"],
      dateRange: [],
      pickerOptions: {
        format: preferences()
          .localization.dateFormat.replace(/D/g, "d") //element ui date format require lowercase
          .replace(/Y/g, "y"),
        shortcuts: [
          {
            text: this.$t("measurement.lastWeek"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("measurement.lastMonth"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("measurement.lastthreeMonth"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("measurement.lastyear"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7 * 52);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.load();
  },
  computed: {
    ...mapState("tree", ["activeTags", "activePoints"]),
    ...mapState("account", ["activeTab"]),
    ...mapState("point", ["points", "status"]),
    ...mapState("tree", ["activeTags", "flatTree"]),
  },
  methods: {
    ...mapActions("tree", ["updateConfig"]),
    ...mapActions("point", ["getPoints"]),
    setDate(startDate, endDate, unit, interval) {
      this.startDate = startDate;
      this.endDate = endDate;
      this.unit = unit;
      this.interval = interval
    },
    riskColor(percentage) {
      return colorLib.getRiskColor(percentage);
    },
    getColor(order) {
      return colorLib.getAlarmColorByOrder(order);
    },
    dateDate(dateArray) {
      return dayjs(dateArray).format(preferences().localization.dateFormat);
    },
    path(id) {
      if (id) {
        return treeHelper.pointIdToPath(this.flatTree,id);
      } else {
        return "";
      }
    },

    load() {

    }
  },
  watch: {
    activeTab(c) {
      if (c == "dashboard") {
        this.load();
        this.updateConfig({
          showCheckbox: true,
        });
      }
    },
    activePoints() {
      if (this.activeTab == "dashboard") {
        this.load();
      }
    }
  },
};
</script>
<style>
.el-table .cell {
  word-break: break-word !important;
}
</style>
<style scoped>
.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.color-box {
  width: 10px;
  height: 10px;
  display: inline-block;
}

.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.alarmTransactions {
  margin-top: 10px;
  border: 1px solid #e4e7ed;
  border-radius: 2px;
}

.header-text {
  margin: 5px;
  padding: 5px;
  font-weight: bold;
  font-size: 16px;
}

.pointHealthScore .el-table .cell {
  word-break: break-word !important;
}

.border.el-table .cell {
  word-break: break-word !important;
}

.tableFlex {
  display: flex;
  flex-direction: column;
  width: 100% !important;
  max-width: 100% !important;
}

.pointHealthScore {
  flex-direction: column;
  height: 620px;
  overflow: hidden;
  border: 1px solid #e4e7ed;
  border-radius: 2px;
  overflow: auto;
}
</style>